export default {
  isOpen: false,
  openingHours: [],
  tenantDetails: ''
}
